<template>
    <div class="index-message">
        <div class="message-icon" @click="handleOpen">
            <i class="el-icon-download"/>
        </div>

        <el-drawer
            title="下载记录"
            :modal="modal"
            :visible.sync="drawer"
            :direction="direction"
            :size="size"
            :before-close="handleClose">

            <div class="message-content">
                <div class="date-group" v-for="(items, key) of dataMap" :key="'date' + key">
                    <div class="date-header">{{ formatDate(key) }}</div>
                    <div class="tasks-container">
                        <div class="task-card" v-for="item in items" :key="item.id">
                            <div class="task-header">
                                <template v-if="item.status === 2">
                                    <a href="javascript:void(0)" @click="handleDownload(item)"
                                       class="task-title download-link">{{ item.fileName || '未命名文件' }}</a>
                                </template>
                                <template v-else>
                                    <span class="task-title">{{ item.fileName || '未命名文件' }}</span>
                                </template>
                                <span class="status-tag" :class="getStatusClass(item.status)">
                    {{ getStatusText(item.status) }}
                  </span>
                            </div>
                            <div class="task-progress" v-if="item.status === 1">
                                <el-progress :percentage="item.progress || 0"></el-progress>
                            </div>
                            <div v-if="item.failReason" class="error-message">
                                {{ item.failReason }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>

export default {
    name: 'indexDownload',
    title: '站内下载',
    props: {},
    components: {},
    methods: {
        // 关闭抽屉
        handleClose (done) {
            console.log(this.timeId)
            clearInterval(this.timeId)
            done()
        },
        // 开启抽屉
        handleOpen () {
            this.drawer = true
            // 重新加载消息列表
            this.current = 1
            this.dataList = []
            this.loadList()
        },
        // 处理搜索条件
        handleCommand (command, e) {
            this.$refs.searchDropdown.innerHTML = e.$el.innerHTML
            this.status = command === 'unread' ? 1 : null
            this.current = 1
            this.dataList = []
            this.loadList()
        },
        // 加载更多
        loadOther () {
            this.current += 1
        },
        // 获取消息列表
        loadList () {
            this.etao.requests.get({
                url: '/etao-report/report-export/getExportTaskList',
                data: {
                    offSet: 0
                },
                successMessage: false,
                success: res => {
                    if (res.data) {
                        // 将新数据与现有数据合并，并按日期排序
                        const sortedData = Object.entries({
                            ...this.dataMap,
                            ...res.data
                        })
                            .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
                            .reduce((acc, [key, value]) => {
                                acc[key] = value
                                return acc
                            }, {})

                        this.dataMap = sortedData
                    }
                }
            })
        },
        getStatusClass (status) {
            switch (status) {
                case 1:
                    return 'status-processing'
                case 2:
                    return 'status-success'
                case 3:
                    return 'status-error'
                default:
                    return ''
            }
        },
        getStatusText (status) {
            switch (status) {
                case 1:
                    return '处理中'
                case 2:
                    return '已完成'
                case 3:
                    return '失败'
                case 0:
                    return '等待中'
                default:
                    return '未知'
            }
        },
        // 添加日期格式化方法
        formatDate (dateStr) {
            const today = new Date()
            const date = new Date(dateStr)

            if (today.toDateString() === date.toDateString()) {
                return '今天'
            }
            return dateStr
        },
        handleDownload (item) {
            fetch(item.link)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a')
                    const objectURL = URL.createObjectURL(blob)
                    link.href = objectURL
                    link.download = item.fileName + (item.link.includes('.') ? '.' + item.link.split('.').pop() : '')
                    link.click()
                    URL.revokeObjectURL(objectURL)
                })
                .catch(error => console.error('下载失败:', error))
        },
        getTaskProgress (taskList) {
        },
        refreshProgress (data) {
            for (let key in this.dataMap) {
                let items = this.dataMap[key]
                for (let item of items) {
                    if (item.id === data.id) {
                        item.progress = data.progress
                        item.status = data.status
                        item.link = data.link
                        item.failReason = data.failReason
                    }
                }
            }
        }
    },
    mounted () {
    },
    data () {
        return {
            unread: 0,
            drawer: false,
            modal: false,
            direction: 'rtl',
            size: '20%',
            current: 0,
            pageSize: 10,
            status: null,
            dataMap: {},
            timeId: null
        }
    },
    destroyed () {
        clearInterval(this.timeId)
    }

}
</script>

<style scoped>
.message-operating {
    margin-left: 2rem;
}

.message-list {
    list-style-type: none;
    padding: 0;
}

.message-item {
    padding: 16px;
    border-bottom: 1px solid #e8e8e8;
    cursor: pointer;
}

.message-item:hover {
    background-color: #fafafa;
}

.message-content {
    font-size: 1rem;
    line-height: 1.8rem;
}

.message-subject {
    font-size: 1rem;
    line-height: 1.8rem;
    width: 100%;
    overflow: hidden; /*超出隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis; /*省略号*/
}

.message-time {
    font-size: 0.7rem;
}

.unread {
    color: #7D8085;
}

.unread > .message-content {
    color: #383838;
}

.read {
    color: #CDCED0;
}

.el-icon-download:hover {
    cursor: pointer;
}

.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.file-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

.status-tag {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
}

.status-processing {
    background: #e6f7ff;
    color: #1890ff;
}

.status-success {
    background: #f6ffed;
    color: #52c41a;
}

.status-error {
    background: #fff2f0;
    color: #ff4d4f;
}

.message-info {
    font-size: 12px;
    color: #999;
    margin-bottom: 8px;
}

.separator {
    margin: 0 8px;
}

.error-message {
    font-size: 12px;
    color: #ff4d4f;
}

.date-group {
    margin-bottom: 24px;
}

.date-header {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-left: 16px;
    border-left: 4px solid #1890ff;
}

.tasks-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    padding: 0 16px;
}

.task-card {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    width: 100%;
}

.task-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}

.task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.task-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.task-info {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
}

.download-link {
    color: #1890ff;
    text-decoration: none;
}

.download-link:hover {
    text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/index/indexDownload.vue